/* template */
<template><div class="activities-in-progress"><div class="header"><mpx-image :src="(titleImage)" class="title"/><btn-city-select :city-name="(cityName)" :city-id="(cityId)" class="btn-select-in-activies" v-if="(isMiniProgram && !existCard)"/></div><div class="content"><good-card v-for="(item, index) in (goods)" :key="item['{{ item.good_id }}']" :in-progress="(inProgress)" :good-info="(item)" @good-click="onClick(item)" @btnClick="btnClick(item)" class="good-card-item"/></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m1d5a3a46"}'>
.activities-in-progress
  width 750rpx
.header
  display flex
  flex-flow row nowrap
  justify-content space-between
  align-items center
  padding-right 70rpx
.title
  width 400rpx
  height 116rpx
  flex none
.btn-select-in-activies
  margin-top 20rpx
  flex none
.content
  padding 0 35rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import mpx, { createComponent } from '@mpxjs/core'
import { is, utils, query, hashQuery, invokeShare, canIUse } from '@didi/webx-js'
import { GlobalEnv, navigateTo, sendRecOrderRequest, setPageShareConfig, URLQueries } from '@/lib/webx'
import { goodsClick } from '../../lib/js/goods_webx'
import { EnumGoodsDetailIsSpike, EnumUIActivitiesInProgressType } from '../../lib/webx/defines'
import { TrackMap } from '../../lib/webx/common_methods/track_map'
import { cannotUseHarmonyosShare } from '../../lib/js/util'

const TitleImage = {
  recommend: {
    'zh-CN': 'https://ut-static.udache.com/webx/fe-agility-wyc/DVX-07rOuGpBQnYKRe4RL.png',
    'en-US': 'https://ut-static.udache.com/webx/fe-agility-wyc/XBxH_rIfDWfeNvoIdTsvH.png',
    'zh-HK': 'https://ut-static.udache.com/webx/fe-agility-wyc/UHcCIYHEaDsBI7tYGKW5f.png',
  },
  inProgress: {
    'zh-CN': 'https://ut-static.udache.com/webx/fe-agility-wyc/1sNQTo8hKA7cfyiF_Ni3o.png',
    'en-US': 'https://ut-static.udache.com/webx/fe-agility-wyc/30SQfkBQJEiJJ8SE0buWw.png',
    'zh-HK': 'https://ut-static.udache.com/webx/fe-agility-wyc/01MD6KQ4cjixiCMfZ2k3b.png',
  },
}

createComponent({
  name: 'ActivitiesInProgress',
  properties: {
    type: {
      required: true,
      type: Number,
    },
    goodsList: {
      required: true,
      type: Array,
    },
    algorithmEvent: {
      type: Object,
    },
    cityName: String,
    cityId: [ String, Number ],
    existCard: Boolean,
  },
  attached() {
    TrackMap.index.activitiesGoodsExposed.apply(this)
    // 新-超值专区曝光埋点
    TrackMap.index.recommendGoodsExposed.apply(this)
    // 算法埋点
    try {
      if (this.type === EnumUIActivitiesInProgressType.Recommends && this.algorithmEvent.event_url) {
        this.goods.forEach((good, index) => {
          const params = {
            ...(this.algorithmEvent.event_info || {}),
            item_id: good.goods_id,
            expose_page: good.algorithmEventPageInfo.page,
            expose_pos: good.algorithmEventPageInfo.index,
            event_type: 'sw',
            event_time: Date.now(),
          }
          sendRecOrderRequest(params, this.algorithmEvent.event_url)
        })
      }
    } catch (error) {}
  },
  data: {
    isMiniProgram: is('miniprogram'),
  },
  computed: {
    inProgress() {
      return this.type === EnumUIActivitiesInProgressType.InProgress
    },
    titleImage() {
      if (this.type === EnumUIActivitiesInProgressType.Recommends) {
        return utils.webpUrl(TitleImage.recommend[GlobalEnv.lang])
      }
      if (this.type === EnumUIActivitiesInProgressType.InProgress) {
        return utils.webpUrl(TitleImage.inProgress[GlobalEnv.lang])
      }
      return ''
    },
    goods() {
      if (Array.isArray(this.goodsList)) {
        const list = this.goodsList.length > 2
          ? [ this.goodsList[0], this.goodsList[1] ]
          : this.goodsList
        return list.map((item, index) => ({
          ...item,
          algorithmEventPageInfo: {
            page: 1,
            index,
          },
        }))
      } else {
        return []
      }
    },
  },
  methods: {
    onClick(good) {
      TrackMap.index.activitiesGoodsClick.call(this, good)
      if (this.inProgress) {
        // 进行中跳转
        if (good.is_spike === EnumGoodsDetailIsSpike.Group) {
          // 跳转拼团
          navigateTo('goodsProcess', {
            ...Object.assign({}, query(), hashQuery()),
            groupId: good.xp_extra.group_id,
            orderId: good.xp_extra.order_id,
            id: good.goods_id,
            prev: 'goodsDetail',
          })
        }
        if (good.is_spike === EnumGoodsDetailIsSpike.Bogo) {
          // 跳转买赠
          navigateTo('orderDetail', {
            from: GlobalEnv.from,
            token: GlobalEnv.loginInfo.token,
            id: good.xp_extra.order_id,
          })
        }
      } else {
        // 推荐位跳转
        goodsClick(good, {
          source: 'landpage',
          trip_cityid: URLQueries.getQuery('trip_cityid'),
          access_key_id: URLQueries.getQuery('access_key_id'),
        }, this.algorithmEvent)
      }
    },
    async btnClick(item) {
      if (item.is_spike === EnumGoodsDetailIsSpike.Group) {
        if (cannotUseHarmonyosShare()) {
          mpx.showToast({
            title: '抱歉，当前APP系统版本不支持该操作，可以在升级版本后尝试此操作',
            icon: 'none',
            duration: 2000,
          })
          return
        }
        const extra = item.extra || {}
        const shareConf = await setPageShareConfig({
          pathname: 'goodsProcess',
          shareData: {
            title: extra.share_title,
            content: extra.share_desc,
            icon: item.share_thumb_pic,
          },
          extraQueries: {
            groupId: item.xp_extra?.group_id,
          },
        })
        canIUse('invokeShare') && invokeShare(shareConf)
        event.stopPropagation()
      }
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "activities_in_progress1d5a3a46",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'good-card':getComponent(require("../../../node_modules/@didi/trade-sdk/lib/quartz/ui/good_card/index.mpx?component=true&componentId=index4ce63343")),'btn-city-select':getComponent(require("./navigation_bar/components/btn_city_select.mpx?component=true&componentId=btn_city_select4c940890")),'mpx-image':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
